export const DELAY_KEYS = {
  COPY_RECEIPT_TIMEOUT: "copyReceiptTimeout",
  POPUP_TIMEOUT: "popupTimeout"
};
